<template>
  <v-dialog width="350px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout class="ma-0" row wrap>

              <v-flex xs6>
                  <v-radio-group v-model="options">
                      <v-radio label="gleichmäßig" :value="1"></v-radio>
                      <v-radio style="margin-top: 36px" label="bei Abstand" :value="2"></v-radio>
                  </v-radio-group>
              </v-flex>

              <v-flex xs5>
                  <v-text-field label="Anzahl Teile" type="number" :disabled="options==2" v-model.number="Anzahl"></v-text-field>
                  <v-text-field label="Abstand" type="text" :disabled="options==1" :suffix="LängenEinheit.name" v-model="Abstand"></v-text-field>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import KnotenClass from '../../js/Knoten.js'

export default {
    data(){
        return{
            options: 1,
            Anzahl: 1,
            Abstand: '0',

            LängenEinheit: this.$store.state.LängenEinheiten.m,
        }
    },
    computed: {
        title() { return 'Stab teilen'},
        viewMenu: {
            get() { return this.$store.getters.vDivideStabMenu },   
            set(value) { this.$store.commit('setvDivideStabMenu', value)} 
        },
    },
    methods: {
        apply(){
            this.$store.dispatch('divideStab', {option: this.options, value: this.options == 1 ? parseInt(this.Anzahl) : parseFloat(this.Abstand.replace(',','.'))})
            this.viewMenu = false
        },
        cancel(){
            this.viewMenu = false
        },
    },
}
</script>

<style>
    input[type=number] {
        text-align: right
    }
</style>